import { render, staticRenderFns } from "./ModalConfirmacao.vue?vue&type=template&id=0b408216&"
import script from "./ModalConfirmacao.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports